// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layer-content-outer[data-v-5178fed0]{display:flex;align-items:flex-start;padding:10px 5px}.dect-w-box[data-v-5178fed0]{flex:1}.line-width[data-v-5178fed0]{width:50px;height:28px;border:1px solid #dcdfe6;border-radius:3px;margin-right:5px}.card-content[data-v-5178fed0]{padding:5px}.baogao-hang[data-v-5178fed0]{position:absolute;bottom:23px;left:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
